import api from './api';
import authHeader from './auth-header';

/** Nastavenia hlasového AI asistenta + spustenie hovoru zamestnancovi. */
class AiAgentService {
    getConfig() {
        return api.get('/ai-agent/config', { headers: authHeader() });
    }

    saveConfig(config) {
        return api.put('/ai-agent/config', config, { headers: authHeader() });
    }

    getEmployees() {
        return api.get('/ai-agent/employees', { headers: authHeader() });
    }

    callEmployee(employeeId, { task = '', record = false } = {}) {
        return api.post('/ai-agent/call', { employeeId, task, record }, { headers: authHeader() });
    }

    /** AI zavolá na telefónne číslo cez Telnyx – nemusí ísť o zamestnanca. */
    callPhone(phone, { task = '', record = false } = {}) {
        return api.post('/ai-agent/phone-call', { phone, task, record }, { headers: authHeader() });
    }

    getHistory() {
        return api.get('/ai-agent/history', { headers: authHeader() });
    }

    getHistoryDetail(callId) {
        return api.get(`/ai-agent/history/${encodeURIComponent(callId)}`, { headers: authHeader() });
    }

    deleteHistoryItem(callId) {
        return api.delete(`/ai-agent/history/${encodeURIComponent(callId)}`, { headers: authHeader() });
    }

    deleteHistory() {
        return api.delete('/ai-agent/history', { headers: authHeader() });
    }
}

export default new AiAgentService();
